import React, { useEffect, useState } from "react";
import { Plus, ClipboardList, Check } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PageHeader, Card, Badge, Loading, Modal, EmptyState } from "../components/ui";

export default function Surveys() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: "", description: "", questions: "" });
  const canCreate = ["SUPERADMIN", "HR_ADMIN", "MANAGER"].includes(user?.role);

  const load = () => api.get("/surveys").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    await api.post("/surveys", { title: form.title, description: form.description, questions: form.questions.split("\n").filter(Boolean) });
    setOpen(false); setForm({ title: "", description: "", questions: "" }); load();
  };
  const respond = async (id) => { await api.post(`/surveys/${id}/respond`); load(); };
  if (!items) return <Loading />;

  return (
    <div>
      <PageHeader title="Surveys" subtitle="Employee feedback & pulse checks">
        {canCreate && <button data-testid="add-survey" onClick={() => setOpen(true)} className="btn-accent"><Plus size={16} /> New Survey</button>}
      </PageHeader>
      {items.length === 0 ? <EmptyState icon={ClipboardList} title="No surveys" /> : (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {items.map((s) => (
            <Card key={s.id} className="flex flex-col p-6" data-testid={`survey-${s.id}`}>
              <div className="flex items-start justify-between"><div className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent/10 text-accent"><ClipboardList size={18} /></div><Badge value={s.status} /></div>
              <h3 className="mt-3 font-head text-base font-bold text-slate-900 dark:text-white">{s.title}</h3>
              <p className="mt-1 flex-1 text-sm text-slate-500 dark:text-slate-400">{s.description}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs text-slate-400">{s.questions?.length || 0} questions · {s.responses} responses</span>
                <button data-testid={`respond-${s.id}`} onClick={() => respond(s.id)} className="flex items-center gap-1 text-xs font-semibold text-accent hover:underline"><Check size={13} /> Respond</button>
              </div>
            </Card>
          ))}
        </div>
      )}
      <Modal open={open} onClose={() => setOpen(false)} title="New Survey"
        footer={<><button onClick={() => setOpen(false)} className="btn-outline">Cancel</button><button form="sv-form" className="btn-accent">Create</button></>}>
        <form id="sv-form" onSubmit={add} className="space-y-4">
          <div><label className="label">Title *</label><input required data-testid="sv-title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="input" /></div>
          <div><label className="label">Description</label><input data-testid="sv-desc" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="input" /></div>
          <div><label className="label">Questions (one per line)</label><textarea data-testid="sv-questions" value={form.questions} onChange={(e) => setForm({ ...form, questions: e.target.value })} className="input h-28 py-2" /></div>
        </form>
      </Modal>
    </div>
  );
}
